import React, { useEffect, useState } from 'react';

import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { reducer } from './state/Reducer';
import CustomContext from './state/CustomContext';
import { Header } from './components/header';
import { Body } from './components/body';
import { BrowserRouter } from 'react-router-dom';
import { MenuSection } from './components/common/Menu';
import { getEmptyUserInfo } from './utilities/helper';
// import WebRTCComponent from './components/HIS/Video';
// import MultiCamRoom from './components/HIS/Video/Group5';
function App() {
  const [userState, usersDispatch] = React.useReducer(reducer, {});
  const [showMenu, setShowMenu] = useState(false);
  useEffect(() => {
    let action: any = getEmptyUserInfo()
    Object.keys(action).forEach((key: string) => {
      action[key] = window.sessionStorage.getItem(key) || ''
    });
    usersDispatch({ ...action, type: 'UPDATE_LOGIN' })

  }, [])
  const providerState = {
    state: userState,
    dispatch: usersDispatch,
  };
  // return <WebRTCComponent />

  return (

    <CustomContext.Provider value={providerState}>
      <BrowserRouter>
        <div className="amulance-app">
          {showMenu && userState.role_id && (
            <div className='menu-outer-panel' onClick={() => {
              setShowMenu(!showMenu)
            }}>
              <div className='menu-panel'>
                {userState.role_id !== 1 && (
                  <>
                    <MenuSection item={{
                      name: "Patient", children: [{
                        name: "View", route: "patient-view"
                      }]
                    }} />
                  </>)}
                {userState.role_id === 1 && (
                  <>
                    <MenuSection item={{
                      name: "Patient", children: [{
                        name: "Register", route: "patient-register"
                      }, {
                        name: "View", route: "patient-view"
                      }]
                    }} />
                    <MenuSection item={{
                      name: "Tenant", children: [{
                        name: "Create", route: "tenant-create"
                      }, {
                        name: "View", route: "tenant-view"
                      }]
                    }} />
                    <MenuSection item={{
                      name: "Hospital", children: [{
                        name: "Create", route: "hospital-create"
                      }, {
                        name: "View", route: "hospital-view"
                      }]
                    }} />
                    <MenuSection item={{
                      name: "Branch", children: [{
                        name: "Create", route: "branch-create"
                      }, {
                        name: "View", route: "branch-view"
                      }]
                    }} /></>)}
                {/* <MenuSection item={{
                  name: "Ambulance", children: [{
                    name: "Create", route: "ambulance-create"
                  }, {
                    name: "View", route: "ambulance-view"
                  }]
                }} /> */}
              </div>
            </div>
          )}
          <Header setToggleForMenu={() => {
            setShowMenu(!showMenu)
          }} />
          <div className='body-panel'>
            <Body />
          </div>
          <div className='footer-panel'>
            @Copy rights reserved for MGM Healthcare Pvt Ltd
          </div>
        </div>
      </BrowserRouter>
    </CustomContext.Provider>
  );
}

export default App;
